import './global.css';

import {
  createBrowserRouter,
  Outlet,
  Route,
  RouterProvider,
  Routes,
} from 'react-router-dom';

import Main from './pages/main';
import Activities from './pages/activities';
import Faq from './pages/faq';
import Privacy from './pages/privacy';

import NewHeader from './components/header';
import NewFooter from './components/footer';
import MainContainer from './components/mainContainer';
import Content from './components/content';

function Root() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route exact path="/" element={<Main />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/faq" element={<Faq />} />
      </Route>
    </Routes>
  );
}

const router = createBrowserRouter([{ path: '*', Component: Root }]);

export default function App() {
  return <RouterProvider router={router} />;
}

function Layout() {
  return (
    <MainContainer>
      <NewHeader />
      <Content>
        <Outlet />
      </Content>
      <NewFooter />
    </MainContainer>
  );
}
